import { Component } from '@opten/compiler/metadata/component';
import { addClass } from '@opten/dom/add-class';
import { getParentWithClass } from '@opten/dom/get-parent-with-class';
import { removeClass } from '@opten/dom/remove-class';
declare const Cookiebot: any;
@Component({ className: 'js-autocomplete-zip', observe: true })
export class AutocompleteZipComponent {
	private cityElement: HTMLInputElement | null = null;
	private formElement: HTMLFormElement | null = null;
	private geoCoder: google.maps.Geocoder | null = null;

	constructor(private element: HTMLInputElement) {
		if (typeof Cookiebot !== 'undefined') {
			if (Cookiebot.consent && Cookiebot.consent.marketing) {
				this.init();
			}
			window.addEventListener('CookiebotOnAccept', () => {
				this.init();
			});
		} else {
			this.init();
		}
	}

	init() {		
		this.formElement = getParentWithClass(
			this.element,
			'js-form'
		) as HTMLFormElement | null;
		if (this.formElement) {
			this.cityElement = this.formElement.querySelector(
				'.js-autocomplete-city'
			) as HTMLInputElement | null;
			if (this.cityElement) {
				this.element.addEventListener('change', () => {
					if (this.element.value.length > 0) {
						addClass(this.element, 'is-filled');
						if (
							Cookiebot.consent.marketing &&
							this.cityElement &&
							this.cityElement.value.trim().length <= 0
						) {
							const zipCode = this.element.value.trim();
							this.getCityFromZip(zipCode);
						}
					} else {
						removeClass(this.element, 'is-filled');
					}
				});
			}
		}
	}

	initGeocoder() {
		if (typeof google === 'object' && typeof google.maps === 'object') {
			this.geoCoder = new google.maps.Geocoder();
		}
	}

	getCityFromZip(zipCode: string) {
		if (!this.geoCoder) {
			this.initGeocoder();
		}

		const country = this.element.getAttribute('data-country') ?? '';
		if (!country) return;

		const request: google.maps.GeocoderRequest = {
			componentRestrictions: {
				postalCode: zipCode,
				country: country
			}
		};

		this.geoCoder.geocode(request, (results, status) => {
			if (
				status === google.maps.GeocoderStatus.OK &&
				results &&
				results.length > 0
			) {
				const city = this.extractCityFromResults(results[0]);
				if (city && this.cityElement) {
					this.cityElement.value = city;
					this.cityElement.dispatchEvent(new Event('change'));
				}
			}
		});
	}

	extractCityFromResults(result: google.maps.GeocoderResult) {
		const addressComponents = result.address_components;
		for (const component of addressComponents) {
			if (component.types.includes('locality')) {
				return component.long_name;
			}
		}
		for (const component of addressComponents) {
			if (component.types.includes('postal_town')) {
				return component.long_name;
			}
		}
		for (const component of addressComponents) {
			if (component.types.includes('administrative_area_level_3')) {
				return component.long_name;
			}
		}
		for (const component of addressComponents) {
			if (component.types.includes('sublocality')) {
				return component.long_name;
			}
		}
		return null;
	}
}
